import { render, staticRenderFns } from "./currentOrderOne.vue?vue&type=template&id=60051918&scoped=true&"
import script from "./currentOrderOne.vue?vue&type=script&lang=js&"
export * from "./currentOrderOne.vue?vue&type=script&lang=js&"
import style0 from "./currentOrderOne.vue?vue&type=style&index=0&id=60051918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60051918",
  null
  
)

export default component.exports